import {Location} from './location';
import {StripeMetaData} from './stripe';

type CheckoutSessionClient = 'web' | 'mobile';

interface CheckoutSession {
    id: string;
    mode: 'payment' | 'subscription';
    price: string;
    success_url: string;
    cancel_url: string;
    client: CheckoutSessionClient;
    amount: number;
    currency: string;
    // Web values
    url?: string;
    // Mobile values
    ephemeralKeySecret?: string;
    paymentIntentClientSecret?: string;
    customer?: string;
    metadata?: StripeMetaData;
    billing_address_collection?: string;
}

interface CheckoutCreateRequest {
    competitionId: string;
    successUrl: string;
    cancelUrl: string;
    client: CheckoutSessionClient;
    location?: Location;
    clubId?: string;
    teamId?: string;
    version?: 'v2';
}

enum CheckoutCreateError {
    MissingLocation = 'missing-location',
    LocationNotAllowed = 'location-not-allowed',
    UserAlreadyRegistered = 'user-already-registered',
    CompetitionFull = 'competition-full',
    CompetitionClosed = 'competition-closed',
    CompetitionDoesNotExist = 'competition-does-not-exist',
    TeamDoesNotExist = 'team-does-not-exist',
    TeamMissing = 'team-missing',
    TeamDoesNotHaveEnoughMembers = 'team-does-not-have-enough-members',
    UserNotInTeam = 'user-not-in-team',
}

interface CheckoutCreateResponse {
    checkoutSessionId?: string;
    hasJoined?: boolean;
    error?: CheckoutCreateError;
    fixtureId?: string;
}

export type {CheckoutSession, CheckoutCreateRequest, CheckoutCreateResponse, CheckoutSessionClient};

export {CheckoutCreateError};
